mutation ReorderHifoCascadePitches(
  $hifoCascadeId: ID!
  $pitchOrdering: [PitchOrderingInput!]!
) {
  reorderHifoCascade(
    input: { hifoCascadeId: $hifoCascadeId, pitchOrdering: $pitchOrdering }
  ) {
    hifoCascade {
      id
    }
  }
}
